export default __webpack_public_path__ + "dbdcbc6a47ff3311c4d1752e28122fa7.png";